export function isChunkLoadError(error) {
  const message = error?.message || '';
  return error?.name === 'ChunkLoadError'
    || /failed to fetch dynamically imported module/i.test(message)
    || /error loading dynamically imported module/i.test(message)
    || /importing a module script failed/i.test(message)
    || /loading chunk [\d\w-]+ failed/i.test(message);
}

const CHUNK_LOAD_RECOVERY_PREFIX = 'glowghost:chunk-load-recovery';
const DEFAULT_CHUNK_LOAD_RECOVERY_TTL_MS = 30_000;

export function getChunkLoadRecoveryKey(section = 'app') {
  return `${CHUNK_LOAD_RECOVERY_PREFIX}:${section || 'app'}`;
}

export function shouldAutoReloadChunkLoadError({
  section = 'app',
  now = Date.now(),
  ttlMs = DEFAULT_CHUNK_LOAD_RECOVERY_TTL_MS,
} = {}) {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return false;
  }

  const key = getChunkLoadRecoveryKey(section);

  try {
    const previous = Number(window.sessionStorage.getItem(key) || 0);
    if (Number.isFinite(previous) && previous > 0 && now - previous < ttlMs) {
      return false;
    }
    window.sessionStorage.setItem(key, String(now));
    return true;
  } catch {
    return false;
  }
}
